interface ScrollOptions extends Record<string, unknown> {
  shift?: number;
}
export default function scrollToElement(element: HTMLElement, opts: ScrollOptions = {}) {
  if (!element) {
    return;
  }

  setTimeout(() => {
    let { offsetTop } = element;

    if (opts.shift) {
      offsetTop -= opts.shift;
    }
    window.scrollTo({
      top: offsetTop,
      behavior: 'smooth',
    });
  }, 250);
}
